var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0015 0H5.9985C2.69025 0 0 2.691 0 6C0 7.3125 0.423 8.529 1.14225 9.51675L0.3945 11.7458L2.70075 11.0085C3.6495 11.637 4.78125 12 6.0015 12C9.30975 12 12 9.30825 12 6C12 2.69175 9.30975 0 6.0015 0Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49279 8.47264C9.34804 8.88139 8.77354 9.22039 8.31529 9.31939C8.00179 9.38614 7.59229 9.43939 6.21379 8.86789C4.45054 8.13739 3.31504 6.34564 3.22654 6.22939C3.14179 6.11314 2.51404 5.28064 2.51404 4.41964C2.51404 3.55864 2.95129 3.13939 3.12754 2.95939C3.27229 2.81164 3.51154 2.74414 3.74104 2.74414C3.81529 2.74414 3.88204 2.74789 3.94204 2.75089C4.11829 2.75839 4.20679 2.76889 4.32304 3.04714C4.46779 3.39589 4.82029 4.25689 4.86229 4.34539C4.90504 4.43389 4.94779 4.55389 4.88779 4.67014C4.83154 4.79014 4.78204 4.84339 4.69354 4.94539C4.60504 5.04739 4.52104 5.12539 4.43254 5.23489C4.35154 5.33014 4.26004 5.43214 4.36204 5.60839C4.46404 5.78089 4.81654 6.35614 5.33554 6.81814C6.00529 7.41439 6.54829 7.60489 6.74254 7.68589C6.88729 7.74589 7.05979 7.73164 7.16554 7.61914C7.29979 7.47439 7.46554 7.23439 7.63429 6.99814C7.75429 6.82864 7.90579 6.80764 8.06479 6.86764C8.22679 6.92389 9.08404 7.34764 9.26029 7.43539C9.43654 7.52389 9.55279 7.56589 9.59554 7.64014C9.63754 7.71439 9.63754 8.06314 9.49279 8.47264Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.576fb69bee12f43ecfb26a2f8725fe75.svg";
export { ForwardRef as ReactComponent };